import { RichContentTypeEnum, RichContentUnion } from 'APP/Services/Mattermost/types'
import type { ChatPostProps } from 'APP/Lib/Context'

// @TODO: revisit this type
export interface PostWithProps {
  // Follows the store's ChatPostProps while typing the fields it lacks (structured_description)
  // TODO: remove question.note and description [DIA-88233]
  props?: ChatPostProps & {
    description?: string
    structured_description?: RichContentUnion[]
  }
}

/**
 * v2: subtext comes from structured_description when it's a single text block
 */
const getV2Subtext = (post?: PostWithProps): string | undefined => {
  const structuredDescription = post?.props?.structured_description

  if (
    structuredDescription?.length === 1 &&
    structuredDescription[0].type === RichContentTypeEnum.Text
  ) {
    return structuredDescription[0].description
  }

  return undefined
}

/**
 * legacy: same info lived in `props.question.note` or `props.description`
 * TODO: remove legacySubtext and legacy props.question/description [DIA-88233]
 */
const getLegacySubtext = (post?: PostWithProps): string =>
  post?.props?.question?.note || post?.props?.description || ''

/**
 * Resolves the subtext shown under a post, preferring v2 structured content over legacy props.
 */
export const getPostSubtext = (post?: PostWithProps): string =>
  getV2Subtext(post) ?? getLegacySubtext(post)
